{
    const activeTab = document.querySelector('.topnavbar__tabsitem--active');

    if (activeTab) {
        activeTab.addEventListener('click', (e) => {
            e.preventDefault();
            const windowWidth = window.innerWidth < 1200;

            if (windowWidth) {
                document
                    .querySelector('.topnavbar__tabs')
                    .classList.toggle('topnavbar__tabs--open');
                document
                    .querySelector('.topnavbar__link__carret')
                    .classList.toggle('topnavbar__link__carret--open');
            }
        });
    }

    const langswitch = document.getElementById('langswitchtogg')

    if (langswitch) {
        langswitch.addEventListener('click', function (e) {
            e.preventDefault()
            const drop = this.parentElement.querySelector('.langswitch__drop')
            this.classList.toggle('langswitch__togg--open')
            drop.classList.toggle('langswitch__drop--open')
        })
    }

    const naviMenu = document.querySelector('.mainnavbar-menu')
    const naviMenuOpen = 'mainnavbar-menu--open'
    const naviList = document.querySelector('.mainnavbar-menulist')
    const naviHamburgerOpen = document.querySelector('.mainnavbar-hamburger--open')
    const naviHamburgerClose = document.querySelector('.mainnavbar-hamburger--close',)
    const naviSearchMobileToggle = document.querySelector('.mainnavbar-search-toggle')
    const naviSearchMobile = document.querySelector('.mainnavbar-search')

// Toogle Menu
    function toggleMenu(e) {
        e.preventDefault()

        const menuWrap = document.querySelector('.mainnavbar-menu')
        menuWrap.classList.toggle('mainnavbar-menu--open')
    }

    function toggleSubMenu(e, close = false) {
        e.preventDefault()

        const menuInfo = document.querySelector('.mainnavbar-menulist__info')
        const submenu = e.target.parentElement.querySelector('.mainnavbar-submenu')
        const submenuActive = document.querySelector('.mainnavbar-submenu--active')

        close ? (menuInfo.innerHTML = 'Menu') : (menuInfo.innerHTML = e.target.innerHTML)

        close ? menuInfo.classList.remove('mainnavbar-menulist__info--active') : menuInfo.classList.add('mainnavbar-menulist__info--active')

        close ? submenuActive ? submenuActive.classList.remove('mainnavbar-submenu--active') : null : submenu.classList.add('mainnavbar-submenu--active')
    }

    if (naviHamburgerOpen) {
        naviHamburgerOpen.addEventListener('click', toggleMenu)
    }

    if (naviHamburgerClose) {
        naviHamburgerClose.addEventListener('click', e => {
            toggleMenu(e)
            toggleSubMenu(e, true)
        })
    }

    if (naviMenu) {
        naviMenu.addEventListener('click', e => {
            if (e.target.classList.contains(naviMenuOpen)) {
                toggleMenu(e)
            }
        })
    }

    document.addEventListener('keydown', e => {
        if (e.keyCode === 27 && naviMenu.classList.contains(naviMenuOpen)) {
            toggleMenu(e)
            toggleSubMenu(e, true)
        }
    })

// Toggle in Mobile Menu
    const linksWithSubmenu = Array.from(document.querySelectorAll('.mainnavbar-menulist__link.mainnavbar-menulist__link--submenu',),)
    const naviListBefore = document.querySelector('.mainnavbar-menulist__info')

    if (linksWithSubmenu) {
        linksWithSubmenu.forEach(link => {
            link.addEventListener('click', e => {
                toggleSubMenu(e)
            })
        })
    }

    if (naviListBefore) {
        naviListBefore.addEventListener('click', e => {
            toggleSubMenu(e, true)
        })
    }

    if (naviSearchMobileToggle) {
        naviSearchMobileToggle.addEventListener('click', e => {
            naviSearchMobile.classList.contains('opened') ? naviSearchMobile.classList.remove('opened') : naviSearchMobile.classList.add('opened')
        })
    }
}

async function addPlaceholder() {
    do {
        // eslint-disable-next-line no-promise-executor-return,no-await-in-loop
        await new Promise((resolve) => setTimeout(resolve, 1000));
        let gsc = document.querySelector('#gsc-i-id1');
        if (document.body.contains(gsc)) {
            gsc.placeholder = 'Szukaj';
        }
    } while (document.querySelector('#gsc-i-id1') === null);
}

addPlaceholder();
